import { useMemo } from 'react';

/** The broker group fields the table filters on; also the filter names in the table prefs. */
const BROKER_GROUP_FILTER_FIELDS = ['ledger', 'countryCode'];

/**
 * Filters broker groups in the browser by ledger and country code (countryCode, which falls
 * back to the config's country). Like the Typesense
 * filters in the CRM tables: several values in one filter match any of them, and different
 * filters must all match. Empty filters are ignored.
 */
export const useBrokerGroupFilter = (brokerGroups, filters) =>
	useMemo(() => {
		const activeFilters = BROKER_GROUP_FILTER_FIELDS.filter((field) => filters[field]?.length);
		if (!activeFilters.length) {
			return brokerGroups;
		}
		return brokerGroups.filter((brokerGroup) =>
			activeFilters.every((field) => filters[field].includes(brokerGroup[field])),
		);
	}, [brokerGroups, filters]);
